import { render, staticRenderFns } from "./SearchOptionsByPerson.vue?vue&type=template&id=7c2b4556&scoped=true&"
import script from "./SearchOptionsByPerson.vue?vue&type=script&lang=js&"
export * from "./SearchOptionsByPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2b4556",
  null
  
)

export default component.exports